// Words for values, the same in the office and in a chat.
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** +12505550101 → (250) 555-0101; anything else as given. */
export function phone(e164: string | null | undefined): string {
  if (!e164) return '';
  const m = /^\+1(\d{3})(\d{3})(\d{4})$/.exec(e164);
  return m ? `(${m[1]}) ${m[2]}-${m[3]}` : e164;
}

/** 2025-03-14 → 14 Mar 2025. */
export function day(d: string | null | undefined): string {
  if (!d) return '';
  const [y, m, dd] = d.split('-').map(Number);
  return `${dd} ${MONTHS[(m ?? 1) - 1]} ${y}`;
}

/** 123456 cents → $1,234.56 */
export function money(cents: number): string {
  const v = cents / 100;
  return `${v < 0 ? '−' : ''}$${Math.abs(v).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const plural = (n: number, one: string, many = `${one}s`) => `${n} ${n === 1 ? one : many}`;

/** An instant as the company's clock reads it: "9:52 a.m.", "12 p.m.". */
export function clock(iso: string, timeZone: string): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    hour: 'numeric',
    minute: '2-digit',
    hourCycle: 'h23',
    timeZone,
  })
    .formatToParts(new Date(iso))
    .reduce<Record<string, string>>((m, p) => ({ ...m, [p.type]: p.value }), {});
  const h = Number(parts.hour),
    m = parts.minute ?? '00';
  return `${((h + 11) % 12) + 1}${m === '00' ? '' : `:${m}`} ${h < 12 ? 'a.m.' : 'p.m.'}`;
}

/** An instant's day as the company's calendar reads it: "22 Oct". */
export function dayOf(iso: string, timeZone: string): string {
  const d = new Intl.DateTimeFormat('en-CA', { day: 'numeric', month: 'short', timeZone }).formatToParts(
    new Date(iso),
  );
  return `${d.find((p) => p.type === 'day')?.value} ${d.find((p) => p.type === 'month')?.value.replace('.', '')}`;
}

/** What each $1 brought back, "$4.20"; a dash with nothing spent. */
export const perDollar = (backCents: number, spentCents: number): string =>
  spentCents ? `$${(backCents / spentCents).toFixed(2)}` : '—';

/** A share, 0–1, as a percent to one place ("38.5 %"); a dash with nothing to count. */
export const rate = (r: number | null | undefined): string =>
  r === null || r === undefined ? '—' : `${Math.round(r * 1000) / 10} %`;
